/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import * as global from "../../js/global" ;
	import * as helper from "../../js/helper";
	import full_loading from "../components/full-loading.vue";
    import VueSelect from '../../js/vue-select.js';
	const __vue_script__ ={
        components: {
            full_loading:full_loading,
            vue_select:VueSelect,
        },
		name:'map_search_widget',
        props: {
        },
		data() {
			return {
                global,
                helper,
                frappe,
                property_name:null,
                is_loading:false,
                expense_details:null,
                ad_type_color: '#0000ff',
                property_type_icon: '#0000ff',
                amount: 0
			}
		},
        mounted(){
            var exampleModal = document.getElementById('expenseDetailsModal')
            exampleModal.addEventListener('show.bs.modal', this.get_expense_details)
        },
		methods: {
            get_expense_details: async function(event){
                this.loading = true
                global.emitter.emit("show-full-loading");
                // Button that triggered the modal
                var button = event.relatedTarget;
                // Extract info from data-bs-* attributes
                this.property_name = button.getAttribute('data-bs-property-name');
                this.form_sent = true;
                let params = {
                    property_name : this.property_name
                };
                try {
                    let res = await $.ajax({
                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
                        url: "/api/method/maalek.api.get_expense_details",
                        type: "GET",
                        data: params //for GET request
                        // data: JSON.stringify(params) //for POST request
                    });
                    if(res.message.total_expense + res.message.children_expense == 0){
                        this.expense_details = "Empty"
                    }else{
                        this.expense_details = res.message
                    }
                    this.loading = false
                    global.emitter.emit("hide-full-loading");
                    this.$forceUpdate();
                } catch (e) {
                    console.log("failed");
                    console.log(e);
                    var exceptions = helper.showException(e);
                    $("#expenseDetailsModal").modal('hide');
                }
                
                this.loading = false
                global.emitter.emit("hide-full-loading");
            },
		},
		computed:{
		}
	}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade filter-popup-area",
      attrs: {
        id: "expenseDetailsModal",
        "data-bs-keyboard": "false",
        tabindex: "-1",
        "aria-labelledby": "staticBackdropLabel",
        "aria-hidden": "true"
      }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
        },
        [
          _vm.expense_details != null
            ? _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "h5",
                    {
                      staticClass: "modal-title",
                      attrs: { id: "staticBackdropLabel" }
                    },
                    [_vm._v(_vm._s(_vm.helper.t("Expense Summary")))]
                  ),
                  _vm._v(" "),
                  _c("button", {
                    staticClass: "btn-close",
                    attrs: {
                      type: "button",
                      "data-bs-dismiss": "modal",
                      "aria-label": "Close"
                    }
                  })
                ]),
                _vm._v(" "),
                _vm.expense_details == "Empty"
                  ? _c("div", { staticClass: "modal-body text-center" }, [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.helper.t(
                              "No expense found against this property"
                            )
                          )
                        )
                      ])
                    ])
                  : _c("div", { staticClass: "modal-body" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c("table", { staticClass: "table align-middle" }, [
                            _c("tbody", [
                              _c(
                                "tr",
                                { staticClass: "bg-light" },
                                [
                                  _c("th"),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.expense_details.expense_types,
                                    function(expense, expense_type) {
                                      return _c("th", [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(_vm.helper.t(expense_type)) +
                                            "\n                                    "
                                        )
                                      ])
                                    }
                                  ),
                                  _vm._v(" "),
                                  _c("th", { staticClass: "text-end" }, [
                                    _vm._v(_vm._s(_vm.helper.t("Total")))
                                  ])
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "tr",
                                [
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.helper.t("Main Property"))
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.expense_details.expense_types,
                                    function(expense, expense_type) {
                                      return _c(
                                        "td",
                                        { staticClass: "text-start" },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(expense) +
                                              "\n                                    "
                                          )
                                        ]
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "th",
                                    { staticClass: "text-end bg-light" },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            Object.values(
                                              _vm.expense_details.expense_types
                                            ).reduce(function(partialSum, a) {
                                              return partialSum + a
                                            }, 0)
                                          ) +
                                          "\n                                    "
                                      )
                                    ]
                                  )
                                ],
                                2
                              ),
                              _vm._v(" "),
                              Object.keys(_vm.expense_details.floors).length > 0
                                ? _c(
                                    "tr",
                                    [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(_vm.helper.t("Sub Properties"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.expense_details
                                          .children_expense_types,
                                        function(expense, expense_type) {
                                          return _c(
                                            "td",
                                            { staticClass: "text-start" },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(expense) +
                                                  "\n                                    "
                                              )
                                            ]
                                          )
                                        }
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "th",
                                        { staticClass: "text-end bg-light" },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                Object.values(
                                                  _vm.expense_details
                                                    .children_expense_types
                                                ).reduce(function(
                                                  partialSum,
                                                  a
                                                ) {
                                                  return partialSum + a
                                                },
                                                0)
                                              ) +
                                              "\n                                    "
                                          )
                                        ]
                                      )
                                    ],
                                    2
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("tbody", [
                              Object.keys(_vm.expense_details.floors).length > 0
                                ? _c(
                                    "tr",
                                    [
                                      _c("th", { staticClass: "text-start" }, [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              _vm.helper.t("Total Expense")
                                            ) +
                                            "\n                                    "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.expense_details.expense_types,
                                        function(expense, expense_type) {
                                          return _c(
                                            "th",
                                            { staticClass: "text-start" },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    expense +
                                                      _vm.expense_details
                                                        .children_expense_types[
                                                        expense_type
                                                      ]
                                                  ) +
                                                  "\n                                    "
                                              )
                                            ]
                                          )
                                        }
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "th",
                                        { staticClass: "text-end bg-light" },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm.expense_details
                                                  .total_expense +
                                                  _vm.expense_details
                                                    .children_expense
                                              ) +
                                              "\n                                    "
                                          )
                                        ]
                                      )
                                    ],
                                    2
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            Object.keys(_vm.expense_details.floors).length > 0
                              ? _c(
                                  "tbody",
                                  [
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "text-center",
                                          attrs: {
                                            colspan:
                                              Object.keys(
                                                _vm.expense_details
                                                  .expense_types
                                              ).length + 2
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm.helper.t(
                                                  "Sub properties expense summary"
                                                )
                                              ) +
                                              "\n                                    "
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "tr",
                                      { staticClass: "bg-light" },
                                      [
                                        _c("th"),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.expense_details.expense_types,
                                          function(expense, expense_type) {
                                            return _c("th", [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.helper.t(expense_type)
                                                  ) +
                                                  "\n                                    "
                                              )
                                            ])
                                          }
                                        ),
                                        _vm._v(" "),
                                        _c("th", { staticClass: "text-end" }, [
                                          _vm._v(_vm._s(_vm.helper.t("Total")))
                                        ])
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.expense_details.floors, function(
                                      floor,
                                      floor_num
                                    ) {
                                      return [
                                        _c("tr", [
                                          _c(
                                            "th",
                                            {
                                              attrs: {
                                                colspan:
                                                  Object.keys(
                                                    _vm.expense_details
                                                      .expense_types
                                                  ).length + 2
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(
                                                    floor_num == 0
                                                      ? _vm.helper.t(
                                                          "Ground Floor"
                                                        )
                                                      : _vm.helper.t(
                                                          "Floor {0}",
                                                          [floor_num]
                                                        )
                                                  ) +
                                                  "\n                                        "
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _vm._l(floor, function(property) {
                                          return _c(
                                            "tr",
                                            [
                                              _c("td", [
                                                _c("img", {
                                                  staticClass: "icon",
                                                  staticStyle: {
                                                    height: "2em",
                                                    width: "auto"
                                                  },
                                                  attrs: {
                                                    src:
                                                      _vm.global.global_params
                                                        .map_icons[
                                                        property.property_type
                                                      ][property.ad_type]
                                                  }
                                                }),
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.helper.t(
                                                        property.property
                                                      )
                                                    ) +
                                                    " : " +
                                                    _vm._s(
                                                      _vm.helper.t(
                                                        property.property_type
                                                      )
                                                    ) +
                                                    "\n                                        "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _vm._l(
                                                property.expense_types,
                                                function(
                                                  expense,
                                                  expense_type
                                                ) {
                                                  return _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-start"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(expense) +
                                                          "\n                                        "
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "th",
                                                {
                                                  staticClass:
                                                    "text-end bg-light"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(
                                                        Object.values(
                                                          property.expense_types
                                                        ).reduce(function(
                                                          partialSum,
                                                          a
                                                        ) {
                                                          return partialSum + a
                                                        },
                                                        0)
                                                      ) +
                                                      "\n                                        "
                                                  )
                                                ]
                                              )
                                            ],
                                            2
                                          )
                                        })
                                      ]
                                    })
                                  ],
                                  2
                                )
                              : _vm._e()
                          ])
                        ])
                      ])
                    ])
              ])
            : _vm._e()
        ]
      )
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-35d3e10b_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"expense-details-modal.vue"}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/modal/expense-details-modal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__